import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiMail, FiPhone, FiMapPin, FiFacebook, FiTwitter, FiLinkedin, FiInstagram } = FiIcons;

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      {/* Notice Section */}
      <div className="bg-yellow-50 border-t border-yellow-200 py-8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg p-6 shadow-sm border border-yellow-300">
            <h3 className="text-lg font-semibold text-yellow-800 mb-3">⚠️ Notice</h3>
            <p className="text-yellow-700 leading-relaxed mb-4">
              This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
            </p>
            <p className="text-yellow-700 leading-relaxed mb-4">
              🔒 We never share any client website made under this offer with others – your project privacy is 100% safe.
            </p>
            <a 
              href="https://projects.azaansuperpc.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-colors"
            >
              👉 Check Offer
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiTrendingUp} className="h-8 w-8 text-primary-400" />
                <span className="text-xl font-bold">TradePro</span>
              </div>
              <p className="text-gray-300 leading-relaxed">
                Your trusted partner in trading success. We provide comprehensive trading solutions and expert guidance to help you achieve your financial goals.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                  <SafeIcon icon={FiFacebook} className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                  <SafeIcon icon={FiTwitter} className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                  <SafeIcon icon={FiLinkedin} className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                  <SafeIcon icon={FiInstagram} className="h-5 w-5" />
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-300 hover:text-primary-400 transition-colors">Home</Link></li>
                <li><Link to="/about" className="text-gray-300 hover:text-primary-400 transition-colors">About Us</Link></li>
                <li><Link to="/services" className="text-gray-300 hover:text-primary-400 transition-colors">Services</Link></li>
                <li><Link to="/portfolio" className="text-gray-300 hover:text-primary-400 transition-colors">Portfolio</Link></li>
                <li><Link to="/contact" className="text-gray-300 hover:text-primary-400 transition-colors">Contact</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Services</h3>
              <ul className="space-y-2">
                <li><span className="text-gray-300">Stock Trading</span></li>
                <li><span className="text-gray-300">Forex Trading</span></li>
                <li><span className="text-gray-300">Crypto Trading</span></li>
                <li><span className="text-gray-300">Portfolio Management</span></li>
                <li><span className="text-gray-300">Trading Education</span></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMapPin} className="h-5 w-5 text-primary-400" />
                  <span className="text-gray-300">123 Trading Street, Financial District, NY 10001</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiPhone} className="h-5 w-5 text-primary-400" />
                  <span className="text-gray-300">+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMail} className="h-5 w-5 text-primary-400" />
                  <span className="text-gray-300">info@tradepro.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © {currentYear} TradePro. All rights reserved.
              </p>
              <p className="text-gray-400 text-sm mt-2 md:mt-0">
                Domain + Hosting + Design = <a href="https://account4web.ca" target="_blank" rel="noopener noreferrer" className="text-primary-400 hover:text-primary-300 transition-colors">Account4Web Inc</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;